/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { CALL_API } from "../middleware";
import { notificationBody } from "../types/api-types";
import {
    GET_BUSINESS_DATE,
    GET_BUSINESS_DATE_SUCCESS,
    GetBusinessDateResponseBody,
    SET_NAVBAR_INFO,
    SET_NAVBAR_INFO_LOADING
} from "../types/navbarInfo";
import { SET_NAVBAR_NOTIFICATIONS } from "../types/onBoarding";

export const getBusinessDate =
    () =>
        async (dispatch: any): Promise<GetBusinessDateResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/dashboard/businessDate',
                    method: 'GET',
                    types: [GET_BUSINESS_DATE_SUCCESS, GET_BUSINESS_DATE],
                },
            });
        };

export const setNavbarInfo =
    ({
        rmName,
        businessDate,
        company,
        environment,
        userRole
    }: {
        rmName: string,
        businessDate: string,
        company: string,
        environment: string,
        userRole: string
    }): {
        type: string;
        rmName: string;
        businessDate: string;
        company: string;
        environment: string;
        userRole: string
    } => {
        return {
            type: SET_NAVBAR_INFO,
            rmName,
            businessDate,
            company,
            environment,
            userRole
        };
    };

export const setNavbarInfoLoading =
    (isNavbarInfoLoading: boolean): { type: string; isNavbarInfoLoading: boolean } => {
        return {
            type: SET_NAVBAR_INFO_LOADING,
            isNavbarInfoLoading
        };
    };


export const storeNotifications = (notifications: notificationBody[]): { type: string; notifications: notificationBody[] } => {
    return {
        type: SET_NAVBAR_NOTIFICATIONS,
        notifications,
    };
}


